import React, {useEffect, useState} from "react";
import {
    Dialog,
} from "@headlessui/react";
import {ArrowDownTrayIcon} from "@heroicons/react/24/outline";

import {useDispatch, useSelector} from "react-redux";
import type {RootState} from "../Store";
import Loader from "../components/Loader";
import Button from "../components/Button";
import {setupWebSocket} from "../components/Websocket";
import {Store} from "../Store";

type Inputs = {
    qty: number;
};

const Order = () => {
    const dispatch = useDispatch();

    const data = useSelector((state: RootState) => state);
    const websocket = useSelector((state: RootState) => state.websocket);
    const clientId = localStorage.getItem("customer_id");

    let [isOpen, setIsOpen] = useState(false);
    let [isDialogLoader, setDialogLoader] = useState(false);
    let [message, setMessage] = useState(
        "Would you like to pour yourself a drink?"
    );
    let [empty, setEmpty] = useState(false);
    let [step, setStep] = useState(0);
    let timeout: any;

    const startPour = async () => {

        const pour = {
            transaction_id: data.transaction.activeItem.id,
            qty: data.transaction.activeItem.qty,
            customer_id: clientId,
            pour_id: data.transaction.activeItem.pour_id
        };

        setDialogLoader(true);
        setMessage("Waiting for pour");

        try {

            timeout = setTimeout(() => {
                setMessage("Something is wrong!");
                setStep(99);
            }, 30000);

            const response = await fetch(`${process.env.REACT_APP_API_URL}/startPour`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify(pour),
            }).then((response) => {
                if (response.status === 200) {
                    setDialogLoader(false);
                    setStep(1);
                } else {
                    return response.json();
                }
            });

        } catch (error) {
            console.error(error);
        }

    };

    function dateFormat(date: any) {

        return new Date(date).toLocaleString("en-US", {
            month: "short", // Jan, Feb, Mar, etc.
            day: "numeric", // 1, 2, 3, etc.
            year: "numeric", // 2022, 2023, etc.
            hour: "numeric", // 12-hour format
            minute: "numeric", // Minutes
            hour12: true, // Use AM/PM
        })

    }

    useEffect(() => {


        const wsManager = setupWebSocket(Store, clientId, {maxRetries: 10, retryInterval: 1000});
        return () => {
            wsManager.close();
        };

    }, []);

    useEffect(() => {

        if (data.transaction.request === 0) {
            setEmpty(true);
        }

    }, [data.transaction]);

    useEffect(() => {

        if (websocket.last.data?.status) {

            if (websocket.connected) {

                setStep(websocket.last.data.status);
                setDialogLoader(false);

                switch (websocket.last.data.status) {
                    case "OKToPour":
                        setMessage("Ready to pour");
                        setStep(2);
                        clearTimeout(timeout);
                        break;
                    case "PourCompleted":
                        setMessage("Pour End");
                        setStep(3);
                        break;
                    default:
                        setMessage("Something is wrong!");
                        setStep(99);
                        break;
                }

            }

        }

    });

    const endPour = () => {

        window.location.reload();

    }

    return (
        <>
            {empty == false && <Loader/>}

            <div className="p-6">
                <div className="space-y-4">
                    <h4 className="text-2xl font-semibold text-gray-900 text-center">
                        Ready to pour
                    </h4>

                    {empty == false && <Loader/>}

                    {data.transaction.activeItem.qty > 0 ? (
                        <>
                            <div className="flex flex-col bg-gray-100 rounded-xl p-4 mx-auto">
                                <div>
                                    <dl className="flex items-center justify-between gap-4 text-xl">
                                        <div className="text-gray-900">
                                            #{data.transaction.activeItem.position}  {data.transaction.activeItem.beverage_name}
                                        </div>
                                        <div className="text-gray-900 ">
                                            {data.transaction.activeItem.qty}{" "}
                                            <strong>{data.transaction.activeItem.unitName}</strong>
                                        </div>
                                    </dl>
                                </div>
                                <Button
                                    style="checkout"
                                    type="button"
                                    onClick={() => setIsOpen(true)}
                                >
                                    Unlock<br/> The Tap
                                </Button>
                            </div>
                        </>
                    ) : (
                        <p className="text-base font-medium text-gray-700 text-center bg-gray-100 p-2 rounded-md">
                            No active orders
                        </p>
                    )}

                    <h4 className="text-2xl font-semibold text-gray-900 ">
                        Order History
                    </h4>

                    {data.transaction.items.length > 0 ? (
                        data.transaction.items.map((item: any, indx: number) => {

                            return (
                                <div
                                    key={indx}
                                    className="flex flex-col bg-white border border-gray-300 rounded-xl p-4"
                                >
                                    <div className="space-y-2">
                                        <div className="flex items-center justify-between gap-4">
                                            <div className="text-gray-600 ">{item.beverage_name}</div>
                                            <div className="text-base font-medium text-gray-600 ">
                                                {(item.qtyUsed)}{"/"}{(item.qty)}{" "}
                                                <strong>{item.unitName}</strong> / {item.totalPrice} $
                                            </div>
                                        </div>
                                        <div className="flex items-center justify-between gap-4">
                                            <div className="text-gray-400 text-sm">
                                                {dateFormat(item.updated_at)}
                                            </div>
                                            <div className="flex items-center font-medium text-sm text-linkBlue">
                                                <a target={'_blank'} href={process.env.REACT_APP_FILE_URL + "invoice-" + item.id + clientId + ".pdf"}>Download receipt </a>
                                                <ArrowDownTrayIcon className="pl-1 h-4 w-4 text-linkBlue"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <p className="text-base font-medium text-gray-700 text-center bg-gray-100 p-2 rounded-md">
                            No past orders
                        </p>
                    )}
                </div>
            </div>
            <>
                <Dialog
                    open={isOpen}
                    onClose={() => setIsOpen(false)}
                    className="relative z-50 "
                >
                    <div className="fixed inset-0 flex w-screen items-center justify-center p-4 bg-black bg-opacity-50">
                        <div className="relative p-6 w-full max-w-md max-h-full">
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                                {isDialogLoader == false && step == 0 && (
                                    <div className="flex flex-col justify-between p-6 md:p-5 text-center">
                                        <h3 className="text-xl font-normal">{message}</h3>
                                        <div className="text-xl font-normal py-4">
                                            {data.transaction.activeItem.name}{" "}
                                            <strong>
                                                {data.transaction.activeItem.qty}{" "}
                                                {data.transaction.activeItem.unitName}
                                            </strong>
                                        </div>
                                        <div className="flex gap-4">
                                            <Button
                                                style="secondary"
                                                type="button"
                                                onClick={() => setIsOpen(false)}
                                            >
                                                Cancel
                                            </Button>
                                            <Button style="primary" type="button" onClick={startPour}>
                                                Start
                                            </Button>
                                        </div>
                                    </div>
                                )}

                                {isDialogLoader == true && (
                                    <div className="flex flex-col justify-between p-4 md:p-5 text-center h-30">
                                        <Loader/>
                                    </div>
                                )}

                                {isDialogLoader == false && step == 1 && (
                                    <div className="flex flex-col justify-between p-4 md:p-5 text-center h-30">
                                        <h3 className="text-xl font-normal">
                                            <Loader/>
                                            {message}
                                        </h3>
                                    </div>
                                )}

                                {isDialogLoader == false && step == 2 && (
                                    <div>
                                        <div className="flex flex-col justify-between p-4 md:p-5 text-center h-30">
                                            <h3 className="text-xl font-normal">
                                                <Loader/>
                                                {message}
                                            </h3>
                                        </div>
                                    </div>
                                )}

                                {((isDialogLoader == false && step == 3) || (isDialogLoader == false && step == 99)) && (
                                    <div>
                                        <div className="flex flex-col justify-between p-4 md:p-5 text-center h-30">
                                            <h3 className="text-xl font-normal mt-3 mb-3">
                                                {message}
                                            </h3>
                                                <Button
                                                    style="secondary"
                                                    type="button"
                                                    onClick={() => {
                                                        endPour()
                                                    }}
                                                >
                                                    Cancel
                                                </Button>

                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Dialog>
            </>
        </>
    );
};

export default Order;
